import { Card, Stack, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import usePaths from "Hooks/usePaths";
import { useAppSelector } from "Hooks/useRedux";
import useStations from "Hooks/useStations";
import useSurveys from "Hooks/useSurveys";

export default function Tooltip({ bgcolor }: { bgcolor: any }) {
  const { text } = useAppSelector((state) => state.tooltip);

  const { data: stations } = useStations();
  const { data: paths } = usePaths();
  const { data: surveys } = useSurveys();

  return (
    <Card sx={{ flexGrow: 1, bgcolor, color: "#fff", py: 1, pl: 2, pr: 1 }}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ width: "100%", height: "100%" }}>
        <InfoOutlinedIcon />
        <Typography noWrap className="fa-number">
          {text ||
            `ایستگاه‌ها: ${stations?.length || "0"} | مسیرها: ${paths?.length || "0"} | تقاضای سرویس: ${surveys?.length || "0"}`}
        </Typography>
      </Stack>
    </Card>
  );
}
